<section class="dynamic-collapse financial-summaries-section-items">
	<section class="dynamic-collapse-header">
		<div class="data-info">
			<h3>{{title}}</h3>
			<h2><span>{{total | currency:'GBP':'symbol-narrow':'1.0'}}</span></h2>
		</div>
	</section>
	<section class="dynamic-collapse-main">
		<div class="dynamic-collapse-content">
			<!-- <div class="financial-canvas" *ngIf="showCanvas">
				<div class="chart-wrapper">
					<canvas *ngIf="defaultTheme" baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [legend]="false"
						[chartType]="doughnutChartType" (chartClick)="chartClicked($event)" [colors]="donutColorsDefault"
						width="280px" height="280px">
					</canvas>
					<canvas *ngIf="lifeFileTheme" baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [legend]="false"
						[chartType]="doughnutChartType" (chartClick)="chartClicked($event)" [colors]="donutColorsLifeFile"
						width="280px" height="280px">
					</canvas>
					<canvas *ngIf="pemTheme" baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [legend]="false"
						[chartType]="doughnutChartType" (chartClick)="chartClicked($event)" [colors]="donutColorsPem"
						width="280px" height="280px">
					</canvas>
					<canvas *ngIf="palmersTheme" baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [legend]="false"
						[chartType]="doughnutChartType" (chartClick)="chartClicked($event)" [colors]="donutColorsPalmers"
						width="280px" height="280px">
					</canvas>
				</div>
			</div> -->
			<ng-container *ngIf="defaultTheme">
				<div class="donut" *ngIf="showCanvas">
					<ng-container *ngFor="let value of doughnutChartData; let i = index">
						<div ngbTooltip="{{ value.sectionName + ' ' + value.myPercent + '%'}}" placement="top"
							class="donut__slice" [class]="'donut__slice__' + getSliceLabel(i)"
							[ngClass]="{'highlighted__slice': selectedSections[value.sectionName]}"
							[style.background-color]="getSliceColor(i)"
							[style.width.px]="getSliceWidth(value.myPercent)">
							<span class="value">{{value.myPercent}}</span>
						</div>
					</ng-container>
				</div>
			</ng-container>
			<ng-container *ngIf="lifeFileTheme">
				<div class="donut" *ngIf="showCanvas">
					<ng-container *ngFor="let value of doughnutChartData; let i = index">
						<div ngbTooltip="{{ value.sectionName + ' ' + value.myPercent + '%'}}" placement="top"
							class="donut__slice" [class]="'donut__slice__' + getSliceLabel(i)"
							[ngClass]="{'highlighted__slice': selectedSections[value.sectionName]}"
							[style.background-color]="getSliceColor(i)"
							[style.width.px]="getSliceWidth(value.myPercent)">
							<span class="value">{{value.myPercent}}</span>
						</div>
					</ng-container>
				</div>
			</ng-container>
			<ng-container *ngIf="pemTheme">
				<div class="donut" *ngIf="showCanvas">
					<ng-container *ngFor="let value of doughnutChartData; let i = index">
						<div ngbTooltip="{{ value.sectionName + ' ' + value.myPercent + '%'}}" placement="top"
							class="donut__slice" [class]="'donut__slice__' + getSliceLabel(i)"
							[ngClass]="{'highlighted__slice': selectedSections[value.sectionName]}"
							[style.background-color]="getSliceColor(i)"
							[style.width.px]="getSliceWidth(value.myPercent)">
							<span class="value">{{value.myPercent}}</span>
						</div>
					</ng-container>
				</div>
			</ng-container>
			<ng-container *ngIf="palmersTheme">
				<div class="donut" *ngIf="showCanvas">
					<ng-container *ngFor="let value of doughnutChartData; let i = index">
						<div ngbTooltip="{{ value.sectionName + ' ' + value.myPercent + '%'}}" placement="top"
							class="donut__slice" [class]="'donut__slice__' + getSliceLabel(i)"
							[ngClass]="{'highlighted__slice': selectedSections[value.sectionName]}"
							[style.background-color]="getSliceColor(i)"
							[style.width.px]="getSliceWidth(value.myPercent)">
							<span class="value">{{value.myPercent}}</span>
						</div>
					</ng-container>
				</div>
			</ng-container>
			<ng-container *ngIf="weightmansTheme">
				<div class="donut" *ngIf="showCanvas">
					<ng-container *ngFor="let value of doughnutChartData; let i = index">
						<div ngbTooltip="{{ value.sectionName + ' ' + value.myPercent + '%'}}" placement="top"
							class="donut__slice" [class]="'donut__slice__' + getSliceLabel(i)"
							[ngClass]="{'highlighted__slice': selectedSections[value.sectionName]}"
							[style.background-color]="getSliceColor(i)"
							[style.width.px]="getSliceWidth(value.myPercent)">
							<span class="value">{{value.myPercent}}</span>
						</div>
					</ng-container>
				</div>
			</ng-container>

			<div class="empty-state-container" id="{{emptyId}}" *ngIf="noItems">
				<div *ngIf="filter == 'assets'">
					<img src="../../assets/img/{{themeService.theme}}/assets.svg" alt="Empty state image">
				</div>
				<div *ngIf="filter == 'debts'">
					<img src="../../assets/img/{{themeService.theme}}/debts.svg" alt="Empty state image">
				</div>
				<div *ngIf="filter == 'income'">
					<img src="../../assets/img/{{themeService.theme}}/viewer-now.svg" alt="Empty state image">
				</div>
				<div *ngIf="filter == 'expenses'">
					<img src="../../assets/img/{{themeService.theme}}/viewer-now.svg" alt="Empty state image">
				</div>
				<div class="empty-message">Your plan has no {{titleEmptySection}} values yet.</div>
			</div>
			<div class="box-list">
				<div *ngIf="!noItems" class="help-navigation">Click on a section to explore further.</div>
				<div class="cursor-pointer" *ngFor="let section of mySectionList; let i = index">
					<div class="count-total-values" (click)="filterItemsPerSection(section.sectionName)"
						[ngClass]="{activeValue: chosenValue===section.sectionName}">
						<div class="item-count">
							<span class="count">{{section.itemCount}}</span>
							<span class="x">x</span>
							<div class="item-name">{{section.sectionName}}</div>
						</div>
						<!-- <span class="total-count">{{section.sectionTotal | currency:'GBP':'symbol-narrow':'1.0'}}</span> -->
						<div class="total-count" *ngIf="section.sectionTotal>=0">
							{{section.sectionTotal | currency:'GBP':'symbol-narrow':'1.0'}}</div>
						<div class="total-count" *ngIf="section.sectionTotal<0" style="color:red">
							({{section.sectionTotal * -1 | currency:'GBP':'symbol-narrow':'1.0'}})
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</section>